export default "__VITE_PUBLIC_ASSET__dd602e5e__"